import React, {useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import TableSkeleton from "../../utils/TableSkeleton";
import EmptyTableState from "../../utils/EmptyTableState";
import "../../styles/components/home.css";
import {getAuthToken, getClientIdOfUser, showToast,} from "../../utils/utility";
import {customStyles} from "../../utils/DataTableCustomStyle";
import MapLink from "../../utils/MapLink";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faInfoCircle, faPenToSquare,} from "@fortawesome/free-solid-svg-icons";

import * as Constants from "../../utils/Constants";
import {
    buildPaginationParams,
    DEFAULT_PAGE_SIZE,
    extractPaginationHeaders,
    PAGE_SIZE_OPTIONS,
} from "../../utils/paginationUtils";
import {Tooltip} from "react-tooltip";
import axios from "axios";

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Pagination states
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      name: "Customer ID",
      selector: (row) => row.customerId,
      sortable: true,
      grow: 0.25,
    },
    {
      name: "Customer Name",
      selector: (row) => row.customerName,
      sortable: true,
      grow: 0.5,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
      wrap: true,
      grow: 1,
    },

    {
      name: "Map Location",
      selector: (row) => (
        <MapLink latitude={row.latitude} longitude={row.longitude} />
      ),
      sortable: true,
      grow: 0.35,
    },
    {
      name: "Email ID",
      selector: (row) => row.emailId,
      sortable: true,
      grow: 0.5,
    },
    {
      name: "Phone Number",
      selector: (row) => row.phoneNumber,
      sortable: true,
      grow: 0.5,
    },
    {
      name: "Manage",
      selector: (row) => <CustomerManagement customerId={row.customerId} />,
      sortable: true,
      grow: 0.3,
    },
  ];

  useEffect(() => {
    fetchData(1, perPage);
  }, []);

  const fetchData = async (page, size) => {
    try {
      const endPoint = `${Constants.API_V1}/${getClientIdOfUser()}/customers`;

      axios.defaults.headers.common["Authorization"] = `${
        Constants.BEARER
      } ${getAuthToken()}`;
      setIsLoading(true);

      const params = buildPaginationParams(page, size);
      const response = await axios.get(`${Constants.BASE_URL}${endPoint}`, { params });

      if (response.status === 200) {
        const data = response.data.responseData;
        if (Array.isArray(data)) {
          setCustomers(data);
          const pagination = extractPaginationHeaders(response);
          if (pagination) {
            setTotalRows(pagination.totalCount);
          } else {
            setTotalRows(data.length);
          }
        } else {
          console.error("Data is not an array:", data);
          setError("No Data found");
        }
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error(error);
      setError("Error fetching data");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    fetchData(page, newPerPage);
  };

  function CustomerManagement(customerId) {
    return (
      <>
        <FontAwesomeIcon
          onClick={() => editCustomer(customerId)}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Edit Customer"
          size="lg"
          icon={faPenToSquare}
        />
        &nbsp; &nbsp; &nbsp; &nbsp;
        <FontAwesomeIcon
          onClick={() => deleteCustomer(customerId)}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Delete Customer"
          size="lg"
          icon={faCircleXmark}
        />
      </>
    );
  }

  function editCustomer(customerId) {
    showToast("To be implemented", {
      autoClose: 1500,
      type: "info",
      position: "top-center",
    });
  }

  function deleteCustomer(customerId) {
    showToast("To be implemented", {
      autoClose: 1500,
      type: "info",
      position: "top-center",
    });
  }

  return (
    <div className="space-y-4">
      <div className="overflow-hidden rounded-xl border border-ink-200 bg-white shadow-xs">
        <DataTable
          columns={columns}
          data={customers}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={PAGE_SIZE_OPTIONS}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          responsive
          highlightOnHover
          striped
          progressPending={isLoading}
          progressComponent={<TableSkeleton />}
          noDataComponent={error ? <EmptyTableState variant="error" message={error} /> : <EmptyTableState message="No customers found" />}
          customStyles={customStyles}
        />
      </div>
      <Tooltip id="my-tooltip" />
    </div>
  );
};

export default CustomerList;
